'use client'

import { useEffect, useState } from 'react'

/**
 * Reads the active data-theme from <html> and tracks toggle changes.
 * Extracted from the identical MutationObserver blocks that CompanyLogos and
 * MonitoringStackLogos each hand-rolled.
 */
export function useDocumentTheme(): 'light' | 'dark' {
  const [theme, setTheme] = useState<'light' | 'dark'>('dark')

  useEffect(() => {
    const read = () =>
      setTheme(
        (document.documentElement.getAttribute('data-theme') as
          | 'light'
          | 'dark') || 'dark'
      )
    read()
    const observer = new MutationObserver(read)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    })
    return () => observer.disconnect()
  }, [])

  return theme
}
